/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// https://github.com/maxmarinich/react-alice-carousel
// https://openbase.com/js/react-alice-carousel/documentation#optionsfoverl
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

// styles and images0
import Spinner from '../buttons/Spinner';
import plusImg from '../../assets/icons/plus.svg';
import minusImg from '../../assets/icons/minus.svg';
import spinImg from '../../assets/icons/spin.webp';
import styles from './Main.module.css';
import repeatImg from '../../assets/icons/repeat.svg';

// components

import Select from '../buttons/Select';
import ImgBtn from '../buttons/ImgBtn';
import Input from '../buttons/NumberInput';
import StepSlider from '../buttons/StepSlider';
import SimpleBtn from '../buttons/SimpleBtn';

// code
import ExampleHeader from '../main/ExampleHeader';
import data, { uiData } from '../../logic/data';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class Main extends Component {
  state = {
    busyCount: 0,

    exampleIdx: data.exampleIdx,

    satMax: data.examples[data.exampleIdx].satMax,
    hueMax: data.examples[data.exampleIdx].hueMax,
    brightMax: data.examples[data.exampleIdx].brightMax,
    satStep: data.examples[data.exampleIdx].satStep,
    hueStep: data.examples[data.exampleIdx].hueStep,
    brightStep: data.examples[data.exampleIdx].brightStep,

    saturate: data.examples[data.exampleIdx].saturate,
    hueRotate: data.examples[data.exampleIdx].hueRotate,
    brightness: data.examples[data.exampleIdx].brightness,

    filter: data.examples[data.exampleIdx].filter,
    background: data.examples[data.exampleIdx].background,
    mixBlendMode: data.examples[data.exampleIdx].mixBlendMode,
    opacity: data.examples[data.exampleIdx].opacity,

    busy: false,

    // topImgIdx: 0,
    // bottomImgIdx: 0,
    image: data.images[data.imageIdx],

    imageIdx: data.imageIdx,

    slideNumber: uiData.slideNumber,
  };

  IMAGE_IDX = 0;

  imageRef = React.createRef();

  slide2Val(image = data.imageIdx) {
    this.imageRef.current.slideTo(image);
    this.setState({ imageIdx: image });
  }

  onSlideNumberChange = val => {
    this.slide2Val(val);
  };

  // alice carousel
  initSlider = () => {
    // console.log(this.state.busyCount, this.state.loaded);
    this.setState(prev => ({ busyCount: prev.busyCount + 1 }));
    this.slide2Val();
  };

  handleSlideChanged = e => {
    this.setState(prev => {
      return {
        imageIdx: e.item,
        image: data.images[e.item],
        slideNumber: { ...prev.slideNumber, value: e.item + 1 },
      };
    });
  };

  items = data.images.map(el => (
    <img src={el} className={styles.sliderImg} alt='random' />
  ));

  setStepSLider(val) {
    this.setState({
      exampleIdx: val,
      saturate: data.examples[val].saturate,
      hueRotate: data.examples[val].hueRotate,
      brightness: data.examples[val].brightness,
      satMax: data.examples[val].satMax,
      hueMax: data.examples[val].hueMax,
      brightMax: data.examples[val].brightMax,
      satStep: data.examples[val].satStep,
      hueStep: data.examples[val].hueStep,
      brightStep: data.examples[val].brightStep,
      filter: data.examples[val].filter,
      background: data.examples[val].background,
      mixBlendMode: data.examples[val].mixBlendMode,
      opacity: data.examples[val].opacity,
    });
  }

  // componentDidMount() {
  //   this.setStepSLider(data.exampleIdx);
  // }

  handleExampleChange = val => {
    this.props.onExampleChange(val);
    this.setStepSLider(val);
  };

  // slider change
  handleStepSliderChange = (type, sign, val) => {
    let step, max, key;

    if (type === 'hue') {
      step = data.examples[this.state.exampleIdx].hueStep;
      max = data.examples[this.state.exampleIdx].hueMax;
      key = 'hueRotate';
    } else if (type === 'saturate') {
      step = data.examples[this.state.exampleIdx].satStep;
      max = data.examples[this.state.exampleIdx].satMax;
      key = 'saturate';
    } else {
      step = data.examples[this.state.exampleIdx].brightStep;
      max = data.examples[this.state.exampleIdx].brightMax;
      key = 'brightness';
    }
    let res =
      type === 'hue'
        ? this.state.hueRotate
        : type === 'saturate'
        ? this.state.saturate
        : this.state.brightness;
    if (sign === 'plus') {
      if (res < max) {
        res += step;
      }
    } else if (sign === 'minus') {
      if (res > 0) {
        res -= step;
      }
    } else {
      res = val;
    }
    this.setState({ [key]: res });
  };

  // // blending on parameters update
  // componentDidUpdate(prevProps, prevState) {
  //   const { busyCount, loaded, opacity, data2D, groupIdx, exampleIdx } =
  //     this.state;
  //   if (busyCount === 1) {
  //     // console.log(data2D);
  //     console.log('aa');
  //   }
  // }

  handleClearClick = () => {
    this.setStepSLider(this.state.exampleIdx);
  };

  // HTML code
  render() {
    const { busyCount } = this.state;
    // console.log(loaded)

    return (
      <main className={styles.main} id='main' name='main'>
        {this.state.busy && (
          <img src={spinImg} alt='spinner image' className={styles.busy} />
        )}

        {busyCount < 1 && <Spinner />}

        <div className={styles.slidesHeading}>
          {/* selection */}
          <div className={styles.inputs}>
            <Select
              options={uiData.selectOptions}
              selectedIdx={this.state.exampleIdx}
              onSelectChange={this.handleExampleChange}
            />
          </div>

          <ExampleHeader exampleIdx={this.state.exampleIdx} />

          {/* sliders */}
          <div className={styles.carousels}>
            <div className={styles.layer}>
              {/* <span>שכבה A </span> */}
              <AliceCarousel
                ref={this.imageRef}
                onInitialized={this.initSlider}
                keyboardNavigation
                mouseTracking
                items={this.items}
                onSlideChanged={this.handleSlideChanged}
              />

              <div className={styles.slideNumbers}>
                {data.images.length} /
                <Input
                  obj={this.state.slideNumber}
                  onChange={val => this.onSlideNumberChange(val - 1)}
                />
              </div>
            </div>
          </div>
          <hr />
        </div>
        <div className={styles.result}>
          <hr></hr>
          <p className={styles.resultHeading}>תוצאה </p>

          <div className={`${styles.frames}`}>
            <img src={this.state.image} alt='current frame' />
            <div
              className={`${styles.mask} ${styles.maskCustom}`}
              style={{
                '--saturate': this.state.saturate + '%',
                '--hue-rotate': this.state.hueRotate + 'deg',
                '--brightness': this.state.brightness + '%',
                '--filter': this.state.filter,
                '--mix-blend-mode': this.state.mixBlendMode,
                '--background': this.state.background,
                '--opacity': this.state.opacity,
              }}
            ></div>
          </div>

          {/* inputs */}
          <div className={styles.slider}>
            <ImgBtn
              src={plusImg}
              onClick={() => this.handleStepSliderChange('hue', 'plus')}
              small={true}
            />
            <StepSlider
              title='hue'
              onChange={this.handleStepSliderChange}
              marks
              min={0}
              max={this.state.hueMax}
              step={this.state.hueStep}
              value={this.state.hueRotate}
              valueLabelDisplay='on'
            />
            <ImgBtn
              src={minusImg}
              onClick={() => this.handleStepSliderChange('hue', 'minus')}
              small={true}
            />
          </div>
          <div className={styles.slider}>
            <ImgBtn
              src={plusImg}
              onClick={() => this.handleStepSliderChange('saturate', 'plus')}
              small={true}
            />
            <StepSlider
              title='saturate'
              onChange={this.handleStepSliderChange}
              marks
              min={0}
              max={this.state.satMax}
              step={this.state.satStep}
              value={this.state.saturate}
              valueLabelDisplay='on'
            />
            <ImgBtn
              src={minusImg}
              onClick={() => this.handleStepSliderChange('saturate', 'minus')}
              small={true}
            />
          </div>
          <div className={styles.slider}>
            <ImgBtn
              src={plusImg}
              onClick={() => this.handleStepSliderChange('brightness', 'plus')}
              small={true}
            />
            <StepSlider
              title='brightness'
              onChange={this.handleStepSliderChange}
              marks
              min={0}
              max={this.state.brightMax}
              step={this.state.brightStep}
              value={this.state.brightness}
              valueLabelDisplay='on'
            />
            <ImgBtn
              src={minusImg}
              onClick={() => this.handleStepSliderChange('brightness', 'minus')}
              small={true}
            />
          </div>
          {/* <ImgBtn src={repeatImg} onClick={this.handleClearClick} /> */}
          <div className={styles.clear}>
            <SimpleBtn
              obj={{
                text: 'נקה',
                disabled: false,
              }}
              onClick={this.handleClearClick}
            />
          </div>
          <div className={styles.mobileInputs + ' ' + styles.inputs}>
            <Select
              options={uiData.selectOptions}
              selectedIdx={this.state.exampleIdx}
              onSelectChange={this.handleExampleChange}
            />
          </div>
          <hr></hr>
        </div>
      </main>
    );
  }
}

export default Main;
